const queryString = require('query-string');

import React, { Component } from "react";
import { Container, Row, Col, Button, Input } from "reactstrap";
import { Link } from 'react-router-dom';
import Loader from 'react-loader';
import store from 'store';

import AuthService from '@services/AuthService';
import NewCheckbox from '@components/HTMLelements/NewCheckbox';

import Privacy from '../Privacy/privacy';
import Legal from '../Legal/legal';
import ForceChangePassword from './ForceChangePassword';

class Login extends Component {

	constructor(props) {
		super(props);
		this.state = {
			redirectToReferrer: false,
			credentials: {
				username: '',
				password: ''
			},
			message: '',
			loaded: true,
			isInitialLogin: false,
			forceChangePassword: false,
			policyLoaded: false,
			privacy: false,
			privacyContent: {},
			legal: false,
			legalContent: {}
		}
		this.login = this.login.bind(this);
		this.onKeyup = this.onKeyup.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.backToLogin = this.backToLogin.bind(this);
		this.onCheckboxChange = this.onCheckboxChange.bind(this);
		this.onPasswordChange = this.onPasswordChange.bind(this);

		const qString = queryString.parse(this.props.location.search);
		this.url = qString && qString.url ? qString.url : null;

		store.remove('CorlyticsApiLogin');
	}

	componentDidMount() {
		this.checkIfUserIsLoggedIn();
	}

	checkIfUserIsLoggedIn() {
		this.setState({ loaded: false });

		AuthService.checkIfUserIsLoggedIn().then(resp => {
			if (resp.data.message) {
				this.setState({ loaded: true });
				AuthService.setUserChecked(true);
				this.userIsLoggedIn();
			}
		}).catch(e => {
			this.setState({ loaded: true });
			AuthService.setUserChecked(false);
		});
	}

	login() {
		this.setState({ message: '', loaded: false });

		// show busy
		AuthService.login(this.state.credentials.username, this.state.credentials.password)
			.then(data => {
				if (!data) return;

				if (data.forceScreen) {
					this.setState({
						loaded: true,
						isInitialLogin: data.policies,
						forceChangePassword: data.password
					}, () => {
						if (!this.state.forceChangePassword) this.getPolicies();
					});
					return;
				}
				if (AuthService.isLoggedIn()) {
					this.setState({ loaded: true });
					this.userIsLoggedIn();
				}
				else {
					this.setState({ message: AuthService.getMessage(), loaded: true });
				}
			});
	}

	getPolicies() {
		AuthService.getPolicies().then(resp => {
			this.setState({
				legalContent: resp.data.legal,
				privacyContent: resp.data.privacy,
				policyLoaded: true
			});
		});
	}

	userIsLoggedIn() {
		const location = this.props.location;
		if (!this.url && (!location.state || location.pathname === location.state.from.pathname)) {
			this.props.history.push('/');
		}
		else {
			this.props.history.push(this.url ? this.url : location.state.from.pathname + location.state.from.search)
		}
	}

	onChange(event) {
		const field = event.target.name;
		const credentials = this.state.credentials;
		credentials[field] = event.target.value;
		return this.setState({ credentials: credentials });
	}

	onKeyup(e) {
		if (e.keyCode === 13) return this.login();
	}

	onCheckboxChange(name) {
		this.setState(state => {
			state[name] = !state[name];
			return state;
		});
	}

	onSubmit() {
		if (!this.state.privacy || !this.state.legal) return;

		// Send request to the backend
		const data = {
			legal: this.state.legal,
			privacy: this.state.privacy
		}
		AuthService.acceptPolicies(data).then(resp => {
			if (resp.data.success) {
				AuthService.loginSuccessResponse();
				setTimeout(() => {
					this.setState({ isInitialLogin: false });
					this.props.history.push('/');
				}, 100);
			}
			else AuthService.logout();
		});
	}

	onPasswordChange() {
		this.setState({ forceChangePassword: false }, () => {
			if (this.state.isInitialLogin) this.getPolicies();
		});
	}

	backToLogin() {
		this.setState({ isInitialLogin: false });
	}

	render() {
		/*
		const  from  = this.props.location.state || { from: { pathname: '/' } }
		const  redirectToReferrer  = this.state.redirectToReferrer
	
		if (redirectToReferrer) {
		  return (
			<Redirect to={from}/>
		  )
		}
		*/

		return (
			<div
				className={(!this.state.isInitialLogin || this.state.forceChangePassword ? 'login-page' : '')}
				style={{ overflowX: 'hidden' }}
			>
				{(this.state.isInitialLogin || this.state.forceChangePassword) &&
					<div className="row">
						<div className="col-1"></div>
						<div className="col-10">
							<div className="red-logo" style={{ marginLeft: '0' }}>
								<img src="/img/logo.png" alt="Corlytics Red" />
							</div>
						</div>
					</div>
				}

				{(!this.state.isInitialLogin && !this.state.forceChangePassword) &&
					<div className="overflow-hidden">
						<div className="red-logo">
							<img src="/img/logo.png" alt="Corlytics Red" />
						</div>
					</div>
				}

				{!this.state.isInitialLogin && !this.state.forceChangePassword &&
					<div>
						<div className="app align-items-center login-form">
							<Container>
								<div className="login-form-container">
									<Row>
										<Col>
											<div className="login-form-title">CORLYTICS<br />STRUCTURE, RATE & VISUALISE REGULATION</div>
										</Col>
									</Row>
									<Row className="mb-4">
										<Col>
											<label>Email</label>
											<Input type="text" placeholder="Username" name="username" value={this.state.credentials.username} onChange={this.onChange} onKeyUp={this.onKeyup} />
										</Col>
									</Row>
									<Row className="mb-3">
										<Col>
											<label>Password</label>
											<Input type="password" placeholder="Password" name="password" value={this.state.credentials.password} onChange={this.onChange} onKeyUp={this.onKeyup} />
										</Col>
									</Row>
									{/* <Row className="mb-4">
										<Col>
											<Checkbox
											label={'Keep me logged in'}
											selected={this.state.keep}
											onCheckboxSelect={this.onChangeCheckbox}
											/>
										</Col>
									</Row> */}
									<Row>
										<Col xs="12">
											{this.state.message && <div className="login-error"><span className="text-danger">{this.state.message}</span></div>}
										</Col>
									</Row>
									<Row className="mb-4">
										<Col>
											<Loader loaded={this.state.loaded} left="50px" top="15px" scale={0.5}>
												<Button type="submit" style={{ height: '38px' }} className="px-4 btn btn-primary-new" onClick={this.login} disabled={(this.state.credentials.username == '') || (this.state.credentials.password == '')}>LOGIN</Button>
											</Loader>
										</Col>
									</Row>
									<Row>
										<Col>
											<hr />
										</Col>
									</Row>
									<Row className="mb-4">
										<Col>
											<Link to="/forgotten-password">Forgotten password?</Link>
										</Col>
									</Row>
									<Row>
										<Col className="text-center">
											<div className="bottom-links">
												<a href="https://corlytics.com/privacy/" target="_blank">Privacy</a>
												<a href="https://corlytics.com/legal/" target="_blank">Legal</a>
											</div>
										</Col>
									</Row>
								</div>
							</Container>
						</div>
					</div>
				}

				{this.state.forceChangePassword &&
					<ForceChangePassword onPasswordChange={this.onPasswordChange} />
				}

				{this.state.isInitialLogin && !this.state.forceChangePassword &&
					<div>
						<Loader loaded={this.state.policyLoaded} color='#BD2E2A' top="150px" left="50%">
							<div className="row mb-2">
								<div className="col-1"></div>
								<div className="col-10">
									<Privacy content={this.state.privacyContent} />
									<hr />
									<Legal content={this.state.legalContent} />
									<hr />
								</div>
							</div>
							<div className="row mb-4">
								<div className="col-1"></div>
								<div className="col-10">
									<NewCheckbox
										onchange={this.onCheckboxChange}
										label="I have read the Privacy Notice"
										position="right"
										selected={this.state.privacy}
										name="privacy"
									/>
								</div>
							</div>
							<div className="row mb-4">
								<div className="col-1"></div>
								<div className="col-10">
									<NewCheckbox
										onchange={this.onCheckboxChange}
										label="I have read the Legal Notice"
										position="right"
										selected={this.state.legal}
										name="legal"
									/>
								</div>
							</div>
							<div className="row mb-4">
								<div className="col-1"></div>
								<div className="col-10">
									<hr />
									<div className="row">
										<div className="col">
											<button type="button" className="btn btn-secondary-new" onClick={this.backToLogin}>Cancel</button>
										</div>
										<div className="col text-right">
											<button
												type="button"
												className="btn btn-primary-new"
												disabled={!this.state.privacy || !this.state.legal}
												onClick={this.onSubmit}
											>Submit</button>
										</div>
									</div>
								</div>
							</div>
						</Loader>
					</div>
				}
			</div>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js